import type {
    AccountGetOrderErrorResponse,
    AccountGetOrderSuccessResponse,
    AccountOrdersSuccessResponse,
} from '@libs/common-next';
import type { CustomerOrder } from '@libs/common-node';
import { getLocale } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

type GetOrderParams = {
    orderId: string;
    email?: string | null;
    locale?: string | null;
};

export async function getOrders() {
    const url = CWEA_ENDPOINTS.orders.getOrders;
    return await cweaClient.get<AccountOrdersSuccessResponse[]>(url, {
        withLocale: true,
        useOldFetch: true,
    });
}

export async function getScheduledOrders() {
    const url = CWEA_ENDPOINTS.orders.getScheduledOrders({ locale: getLocale() });
    return await cweaClient.get<AccountGetOrderSuccessResponse[]>(url);
}

export async function getOrder(options: GetOrderParams) {
    const backupLocale = getLocale();
    const url = CWEA_ENDPOINTS.orders.getOrder({
        ...options,
        locale: options.locale ?? backupLocale,
    });
    return await cweaClient.get<CustomerOrder | AccountGetOrderErrorResponse>(url, { useOldFetch: true });
}

export async function getOrderDeliveryMessage(options: GetOrderParams) {
    const backupLocale = getLocale();
    const url = CWEA_ENDPOINTS.orders.getOrderDeliveryMessage({
        ...options,
        locale: options.locale ?? backupLocale,
    });

    const response = await cweaClient.get<{ message: string | null }>(url, { useOldFetch: true });

    if (!response) {
        return null;
    }

    return response.message;
}
